module.exports = __webpack_public_path__ + "media/src/images/h5p_docu_2-7a1e61d1f9add248dbf4da8ceff40fae.png";